enum DashboardType {
    PRICE, COUNT
}

export default DashboardType